import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AccountPlanMessageModal from "./account-plan-message-modal.vue";
import HandleModalShowMixin from "@Broker/@Modules/account-plan/mixins/handle-modal-show-mixin";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { getPlanDetails } from "@Shared/@Utils/utils";
import { PLAN_NAMES } from "@Shared/@Utils/constants";
import AccountPlanPerks from "../account-plan-perks.vue";
import { mapState } from "vuex";
import moment from "moment";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PaymentFailedModal",
  components: {
    AccountPlanMessageModal,
    SimpleButton,
    AccountPlanPerks
  },
  mixins: [HandleModalShowMixin],
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", {
    accountExpirationDate(state) {
      return state.accountDetails.expirationDate;
    }
  })), {}, {
    freeAccountPlan() {
      return getPlanDetails(PLAN_NAMES.FREE);
    },
    planCancellationDate() {
      const expiration = moment(this.accountExpirationDate).add(3, "days");
      return this.$options.filters.formatDate(expiration);
    }
  }),
  methods: {
    handleGoToAccountPlan() {
      this.computedShown = false;
      this.$router.push({
        name: "account-plan-tab",
        params: {
          tab: "current-account"
        }
      });
    }
  }
});